import {app} from "../firebase";
import {getDatabase,ref,get,set,push,child,remove,update} from "firebase/database"

function getVariableCustsCollectionByCompany(companyId) {
  return `companies/${companyId}/variableCosts`;
}

export const saveVariableCust = async (companyId, data) => {
  const db = getDatabase(app);
  if (!companyId) {
    throw new Error("Nenhum ID de empresa fornecido.");
  }
  const cleanData = removeUndefined(data);
  const newVariableCustRef = push(ref(db, getVariableCustsCollectionByCompany(companyId)));
  const newVariableCustId = newVariableCustRef.key;
  await set(newVariableCustRef, cleanData);

  return { id: newVariableCustId, ...cleanData };
};

function removeUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export const deleteVariableCust = async (companyId, VariableCustId) => {
  if (!companyId || !VariableCustId) throw new Error("IDs inválidos para exclusão");
  const db = getDatabase(app);

  await remove(ref(db, `${getVariableCustsCollectionByCompany(companyId)}/${VariableCustId}`));
};

export const updateVariableCust = async (companyId, VariableCustId, data) => {
  if (!companyId || !VariableCustId) throw new Error("IDs inválidos");
  const db = getDatabase(app);
  const cleanData = removeUndefined(data);
  await update(ref(db, `${getVariableCustsCollectionByCompany(companyId)}/${VariableCustId}`), cleanData);
  return { id: VariableCustId, ...cleanData };
};

export const getVariableCusts = async (companyId) => {
  const db = getDatabase(app);
  if (!companyId) throw new Error("Nenhum ID de empresa fornecido.");

  const dbRef = ref(db);
  const snapshot = await get(child(dbRef, getVariableCustsCollectionByCompany(companyId)));

  if (snapshot.exists()) {
    const data = snapshot.val();
    return Object.entries(data).map(([id, value]) => ({
      id,
      ...value,
    }));
  } else {
    return [];
  }
};


